(function(){
	'use strict';

	// When the notice is dismissed
	$('.smp-global-alert .close').on('click', function() {

		// Set the cookie
		// Expire after 7 days
		var cookieName = "site_notice_dismissed_" + $(this).parent().parent().attr('data-alert');
		createCookie(cookieName,'true',7);
	});

	/**
	* Helper: create cookie
	* @param cookieName: string
	* @param cookieValue string
	* @param daysToExpire number
	*/
	function createCookie(cookieName,cookieValue,daysToExpire) {

		var date = new Date();
		date.setTime(date.getTime()+(daysToExpire*24*60*60*1000));
		document.cookie = cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
	}

}());
